module.exports = __webpack_public_path__ + "static/media/th-start__diamond-cy.4f22d471.svg";